import { useSelector } from "react-redux";
import { Empty, Progress, Table } from "antd";
import { UNITS } from "../../../../../Common/Constants";

const ModeTable = () => {
  const eol = useSelector((state) => state.eolTests);
  const vehicleSlice = useSelector((state) => state.eol);
  const vehicleDetails = vehicleSlice?.vehicleDetails;
  const response =
    Object.keys(eol?.dynoStopDetails).length !== 0
      ? eol?.dynoStopDetails
      : eol?.dynoResult;

  const returnSpeedWithIcon = (modeValue, bool) => {
    if (modeValue || modeValue === 0) {
      return {
        speed: modeValue,
        checked: bool,
      };
    }
  };
  const modeResult = (item) => {
    return returnSpeedWithIcon(
      response?.data?.dynoTestResults?.[item.mode]?.modeData?.speed,
      response?.data?.dynoTestResults?.[item.mode]?.modeData?.dyno_result
    );
  };

  const connectionIcon = (status) => {
    if (status === true) {
      return (
        <Progress
          type="circle"
          size={25}
          percent={100}
          strokeColor={{
            "0%": "#108ee9",
            "100%": "#87d068",
          }}
        />
      );
    } else if (status === false) {
      return (
        <Progress type="circle" size={25} percent={100} status="exception" />
      );
    } else {
      return "";
    }
  };

  const columns = [
    {
      title: "Mode",
      dataIndex: "mode",
      key: "mode",
    },
    {
      title: "Target",
      dataIndex: "max",
      key: "max",
      render: (_, record) => `${record.max} ${UNITS.KM_PER_HR}`,
    },
    {
      title: "Speed",
      dataIndex: "speed",
      key: "speed",
      render: (_, record) =>
        modeResult(record)?.speed || modeResult(record)?.speed === 0 ? (
          `${parseFloat(modeResult(record)?.speed).toFixed(2)} ${
            UNITS.KM_PER_HR
          }`
        ) : (
          <span className="disabled">NA</span>
        ),
    },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
      render: (_, record) => connectionIcon(modeResult(record)?.checked),
    },
  ];

  return vehicleDetails?.driveModeSpeed?.length > 0 ? (
    <Table
      className="dyno-mode-table"
      columns={columns}
      rowKey={(record) => record.mode}
      dataSource={vehicleDetails?.driveModeSpeed}
      pagination={false}
      scroll={{ x: "100%" }}
    />
  ) : (
    <div className="pd3025">
      <Empty />
    </div>
  );
};

export default ModeTable;
